export default __webpack_public_path__ + "static/media/spiner.afd216a7.svg";